import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/logo.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Form from '../Form/Form';
import CounterUp from '../CounterUp/CounterUp';
import Whastapp from "../Whastapp/Whastapp";
import Chisiamo from "../Chisiamo/Chisiamo";
import Servizi from "../Servizi/Servizi";
import Contatti from "../Contatti/Contatti";
import AreaRiservata from "../AreaRiservata/AreaRiservata";
import Comeunirti from "../Comeunirti/Comeunirti";
import CosaDicono from "../CosaDicono/CosaDicono";
import Certificazioni from "../Certificazioni/Certificazioni";
import Notizie from "../Notizie/Notizie";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import Card from "../Card/Card";
import Image1Card from "../../Assets/servizi1.png";
import Image2Card from "../../Assets/servizi2.png";
import Image3Card from "../../Assets/servizi3.png";

function Home() {
  return (
    <section>
    <Whastapp />
      <Container fluid className="home-section" id="home">
      
        {/*<Particle />*/}
        <Container className="home-content">
          <Row>
          <div section className="cards">
              <Card
                  title="Amministrazione di proprietà"
                  imageUrl= {Image1Card}
                  body = "Gestione dello stabile con azioni sia di carattere esecutivo (come l’attuazione delle delibere) che amministrativo (ad esempio, gli adempimenti fiscali e tributari)"
              />
              <Card
                  title="Tutela regolamento condominiale"
                  imageUrl= {Image2Card}
                  body = "Regola la vita di condominio, indicando le norme da seguire, ad esempio, sulla ripartizione delle spese e sul decoro del palazzo"
                  />
              <Card
                  title="Gestione sinistri condominiali"
                  imageUrl= {Image3Card}
                  body = "Tutela dei condomini contro gli eventuali danni che potrebbero verificarsi nel fabbricato"
              />
          </div>
          </Row>
          {/*
          <Row>
              <div section className="home-textMove2">
                <h2 style={{ paddingTop: 20 }}>
                  COSA ASPETTI, CONTATTACI SUBITO! SCRIVICI PER AVERE MAGGIORI INFORMAZIONI IN MERITO
                </h2>
              </div>
          </Row> 
          <Row>
          <div className="formtxt-header">
              <h1 style={{ paddingTop: 20 }}>
              Richiedi Preventivo
              </h1>
          </div>    
            <Form />
          </Row>
          <Row>
            <CounterUp
              sta= "0"      //START
              sto= "100"    //STOP
              dur= "2"      //Durata in Sec
              del= "0"      //ritardo
            />
          </Row>
          */}
        </Container>  
      </Container>
      
      {/*PAGINE*/}
      <Chisiamo/>         
      <Servizi/>
      <Contatti/>
      <Comeunirti/>
      <AreaRiservata/>
      {/*<CosaDicono />*/}
      <Certificazioni/>
      {/*<Notizie />*/}

      {/*<Home2 />*/}
    </section>
  );
}

export default Home;
